import { useContext } from 'react';
import { ApplicationContext } from '.';

export const useApplication = () => {
	return useContext(ApplicationContext);
};
